const truncateText = (text, maxLength = 250) => {
    if (text.length > maxLength) {
        return `${text.slice(0, maxLength)}...`;
    }
    return text;
};
export default truncateText;
